import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';
import { normalizeAssets } from '../normalizer/assets.normalizer';

import { actions as authActions } from './auth.reducer';
import { actions as appActions } from './app.reducer';

export const actions = formatActionTypeNames(
	{
		articleAsset: 'ARTICLE_ASSET',
		articles: 'ARTICLES',
		assets: 'ASSETS',
		contacts: 'CONTACTS',
		delContact: 'DEL_CONTACT',
		delUser: 'DEL_USER',
		navigation: 'NAVIGATION',
		pageAsset: 'PAGE_ASSET',
		// pages: 'PAGES',
		popupAsset: 'POPUP_ASSET',
		popups: 'POPUPS',
		permissions: 'PERMISSIONS',
		setArticle: 'SET_ARTICLE',
		setAssets: 'SET_ASSETS',
		setContacts: 'SET_CONTACTS',
		// setPage: 'SET_PAGE',
		setPopup: 'SET_POPUP',
		setPermissions: 'SET_PERMISSIONS',
		setState: 'SET_STATE',
		setUsers: 'SET_USERS',
		delNavigation: 'DEL_NAVIGATION',
		users: 'USERS',
		projectIcons: 'PROJECT_ICONS',
		getDocument: 'GET_DOCUMENT',
		// delDocument: 'DEL_DOCUMENT',
		altTag: 'ALT_TAG',
		siteSettings: 'GET_SITE_SETTINGS',
		setSiteSettings: 'GET_SITE_SETTINGS',
		seo: 'SEO',
		slot: 'SLOT',
		tmpSlot: 'TMP_SLOT',
	},
	'CMS'
);

export const cmsActions = {
	articleAsset: createAction(actions.articleAsset),
	articles: createAction(actions.articles),
	assets: createAction(actions.assets),
	contacts: createAction(actions.contacts),
	delUser: createAction(actions.delUser),
	delContact: createAction(actions.delContact),
	navigation: createAction(actions.navigation),
	pageAsset: createAction(actions.pageAsset),
	// pages: createAction(actions.pages),
	popupAsset: createAction(actions.popupAsset),
	popups: createAction(actions.popups),
	setArticle: createAction(actions.setArticle),
	setAssets: createAction(actions.setAssets),
	setContacts: createAction(actions.setContacts),
	// setPage: createAction(actions.setPage),
	setPopup: createAction(actions.setPopup),
	setState: createAction(actions.setState),
	setUsers: createAction(actions.setUsers),
	delNavigation: createAction(actions.delNavigation),
	users: createAction(actions.users),
	projectIcons: createAction(actions.projectIcons),
	permissions: createAction(actions.permissions),
	setPermissions: createAction(actions.setPermissions),
	getDocument: createAction(actions.getDocument),
	// delDocument: createAction(actions.delDocument),
	altTag: createAction(actions.altTag),
	siteSettings: createAction(actions.siteSettings),
	setSiteSettings: createAction(actions.setSiteSettings),
	seo: createAction(actions.seo),
	slot: createAction(actions.slot),
	tmpSlot: createAction(actions.tmpSlot),
};

export default (state = initialState.cms, action) => {
	const { payload } = action;

	switch (action.type) {
		case appActions.booted:
			return {
				...state,
				siteSettings: payload.siteSettings,
			};

		case actions.setState:
			return {
				...state,
				...payload,
			};

		case actions.setArticle:
			return {
				...state,
				articles: {
					...state.articles,
					...payload,
				},
			};

		case actions.setContacts:
			return {
				...state,
				contacts: {
					...state.contacts,
					...payload,
				},
			};

		case actions.setPopup:
			return {
				...state,
				popups: {
					...state.popups,
					...payload,
				},
			};

		case actions.setAssets:
			return {
				...state,
				assets: {
					...state.assets,
					...normalizeAssets(payload),
				},
			};

		case actions.setUsers:
			return {
				...state,
				users: {
					...state.users,
					...payload,
				},
			};

		case actions.setSiteSettings:
			return {
				...state,
				siteSettings: {
					...state.siteSettings,
					...payload,
				},
			};

		case actions.setPermissions:
			return {
				...state,
				permissions: {
					...state.permissions,
					...payload,
				},
			};

		case actions.delNavigation: {
			const { navigation } = state;
			delete navigation[payload.navID];
			return {
				...state,
				navigation: {
					...navigation,
				},
			};
		}

		case actions.delUser: {
			const { users } = state;
			delete users[payload.userID];
			return {
				...state,
				users: {
					...users,
				},
			};
		}

		case actions.delContact: {
			const { contacts } = state;
			delete contacts[payload.contactID];
			return {
				...state,
				contacts: {
					...contacts,
				},
			};
		}

		case authActions.signupComplete:
		case authActions.loginComplete:
			return {
				...state,
				token: payload.siteSettings,
			};

		case authActions.logoutComplete:
			return initialState.cms;

		default:
			return state;
	}
};
